import { css } from '@emotion/css';

const wrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  min-height: 70vh;
  max-width: 650px;
  padding: var(--spacings-1);
  margin: 0 auto;

  a {
    color: var(--colors-primary-500);
    text-decoration: none;
    transition: all 0.2s ease-in-out;

    &:hover {
      color: var(--colors-primary-700);
      text-decoration: underline;
    }
  }
`;

const text = css`
  &.MuiTypography-root {
    margin-top: var(--spacings-2);
    text-align: center;
  }
`;

const boldText = css`
  &.MuiTypography-root {
    font-weight: bold;
  }
`;

const cardWrapper = css`
  &.MuiCard-root {
    margin-top: var(--spacings-4);
    border: 1px solid var(--colors-neutral-200);
  }
`;

const termsBody = css`
  &.MuiTypography-root {
    color: var(--colors-neutral-400);
  }
`;

const termsBodyButton = css`
  &.MuiButton-root,
  &a {
    text-transform: none;
    font-weight: bold;
    text-decoration: underline;
    color: var(--colors-neutral-400) !important;
    padding: 0 var(--spacings-0);
  }
`;

const termsBodyLink = css`
  text-transform: none;
  font-weight: bold;
  text-decoration: underline !important;
  color: var(--colors-neutral-400) !important;
`;

const termsText = css`
  &.MuiTypography-root {
    color: var(--colors-neutral-500);
  }
`;

const termsButton = css`
  &.MuiButton-root {
    text-transform: none;
    font-weight: bold;
    text-decoration: underline;
    color: var(--colors-primary-900);
  }
`;

const actionButton = css`
  &.MuiButton-root {
    margin-top: var(--spacings-4);
    background-color: var(--colors-primary-500);
    border-radius: var(--radius-2);
    text-transform: none;
    padding: var(--spacings-1) var(--spacings-4);

    &:hover {
      background-color: var(--colors-primary-700);
    }
  }
`;

const modalWrapper = css`
  &.MuiDialog-root {
    .MuiDialog-paper {
      canvas {
        border: none;
      }
    }
  }
`;

const RequestTermsStyles = {
  wrapper,
  text,
  cardWrapper,
  boldText,
  termsBody,
  termsBodyButton,
  termsBodyLink,
  termsText,
  termsButton,
  actionButton,
  modalWrapper,
};

export default RequestTermsStyles;
